// import React, { useContext, useEffect, useState } from 'react';
// import Application from '../../../StateContext/Application.js';
// import { apiurl } from '../../../../../path.js';



// const ReleasefromFinance = () => {

//   const operation = useContext(Application);
//   const { GetProjectInfo, GetBudgetHeadInfo, ReleaseFDUTF, ViewAllReleaseFDUTF } = operation;
//   const [projectId, setProjectId] = useState([]);
//   const [HeadId, setHeadID] = useState([]);
//   const [relatedHeadID, setRelatedHeadID] = useState([]);
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [BugetEstimationDetail, setBudgetEstimationDetail] = useState([]);
//   const [FinanceReleaseData, setFinanceReleaseData] = useState([]);

//   const [data, setData] = useState({
//     FinancialYear: '2024-25',
//     ProjectName: '',
//     ProjectID: '',
//     ReleaseAmountTillDate: '',
//     BudgetHeadID: null,
//     BudgetHeadName: "",
//     ReleaseAmount: 0,
//     ReleaseDate: null,
//   });

//   const HandleChangeData = (e) => {
//     const { name, value } = e.target;
//     setData({ ...data, [name]: value });
//   }

//   // console.log("Head if ", HeadId)

//   // Fetching 
//   const FetchData = async () => {
//     try {
//       let res = await GetProjectInfo('null', "all");
//       let res1 = await GetBudgetHeadInfo('null', "all");
//       let res3 = await ViewAllReleaseFDUTF();
//       let res4 = await GetBudgetHeadInfo('null', "GetALLBugetEstimation");
//       let res5 = await GetBudgetHeadInfo('null', "GetAllFinanceFromReleaseTable");
//       console.log("Tbale data ::", res4);
//       setProjectId(res);
//       setHeadID(res1);
//       setTableData(res3)
//       setBudgetEstimationDetail(res4);
//       setFinanceReleaseData(res5)
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   const HeadIDFetchOperation = async (ID, IDtype) => {
//     try {
//       console.log(ID);
//       if (IDtype == "ProjectId") {
//         let res1 = await GetProjectInfo(ID, "id");
//         console.log("Proposal ID ingo :: ", res1);
//         let projectData = res1[0];

//         console.log("project data i sleected ", projectData);

//         let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
//         console.log("Head related to project ", apple)
//         setRelatedHeadID(apple);



//         setData((prev) => ({
//           ...prev,
//           FinancialYear: projectData.FinancialYear,
//           ProjectName: projectData.ProjectName,
//           ProjectID: projectData.ProjectId,
//           ReleaseAmountTillDate: projectData.ProjectCost,
//           ProjectCost: projectData.ProjectCost,
//           piu: projectData.PIU,
//           GRCopy: projectData.GRCopy
//         }))
//       } else if (IDtype == "HeadID") {
//         let res1 = await GetBudgetHeadInfo(ID, 'id');
//         console.log("Head ID info ", res1);
//         let HeadData = res1[0];
//         setData((prev) => ({
//           ...prev,
//           BudgetHeadID: HeadData.HeadID,
//           BudgetHeadName: HeadData.HeadName,
//         }))
//       }
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   const uniqueHeads = [];

//   const filteredData = HeadId.filter(item => {
//     const isDuplicate = uniqueHeads.includes(item.HeadName);
//     if (!isDuplicate) {
//       uniqueHeads.push(item.HeadName);
//       return true;
//     }
//     return false;
//   });


//   console.log("Filltered Data ", filteredData)

//   useEffect(() => {
//     FetchData()
//   }, [])



//   // estimation 

//   const getGroupedEstimationData = () => {
//     const grouped = {};

//     BugetEstimationDetail.forEach(item => {
//       const key = `${item.Year}_${item.Taluka || "--"}`;
//       if (!grouped[key]) {
//         grouped[key] = {
//           Year: item.Year,
//           BudgetID: item.BudgetID, // optional: you might want to list them all
//           BudgetHead: item.BudgetHead,
//           Taluka: item.Taluka || "--",
//           LimitAllotedAmount: item.LimitAllotedAmount,
//           DemandRequestAmount: item.DemandRequestAmount,
//           EsitmateAmount: item.EsitmateAmount,
//         };
//       }

//       // grouped[key].EsitmateAmount += Number(item.EsitmateAmount) || 0;
//     });

//     return Object.values(grouped);
//   };


//   const getGroupedFinance = () => {
//     const grouped = {};

//     FinanceReleaseData.forEach(item => {
//       const key = `${item.Year}_${item.Taluka || "--"}_${item.ReleaseID}`;
//       if (!grouped[key]) {
//         grouped[key] = {
//           FinancialYear: item.FinancialYear,
//           HeadCode: item.HeadCode,
//           District: item.District,
//           ProposalID: item.ProposalID,
//           ProposalCost: item.ProposalCost,
//           LimitAllotedAmount: item.LimitAllotedAmount,
//           DemandRequestAmount: item.DemandRequestAmount,
//           ReleaseDate: item.ReleaseDate
//         };
//       }

//       grouped[key].ReleaseAmountTillDate += Number(item.ReleaseAmountTillDate) || 0;
//     });

//     return Object.values(grouped);
//   };







//   return (
//     <>
//       {/* <div className="col-12 ">
//         <h3 className='text-center fw-bold bg-light'>Release From FD/UTF</h3>
//         <div className="col-12 m-auto my-5 budgetContainer">
//           <div className="m-auto budgetElement">
//             {loading && (
//               <div
//                 style={{
//                   position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                   display: 'flex', justifyContent: 'center', alignItems: 'center'
//                 }}>
//                 <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                 <style>
//                   {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                 </style>
//               </div>
//             )}
//             <form action="">
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>Financial Year</label>
//                   </div>
//                   <div className="col-7">
//                     <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData}>
//                       <option value="null">Choose Financial Year</option>
//                       <option value="2024-2025">2024 - 2025</option>
//                       <option value="2025-2026">2025 - 2026</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5 my-auto ">
//                     <label className='my-auto' >Proposal Name</label>
//                   </div>
//                   <div className="col-7">
//                     <select name="ProjectID" value={data.ProjectID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "ProjectId") }}>
//                       < option value="null">Choose Proposal</option>
//                       {projectId && projectId.map((val, index) => {
//                         return (
//                           <option key={index} value={val.ProjectId}>{val.ProjectName}</option>
//                         )
//                       })
//                       }
//                     </select>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5 my-auto ">
//                     <label className='my-auto'>Release Amount Till Date</label>
//                   </div>
//                   <div className="col-7">
//                     <p className='py-2 px-2'> {data.ProjectCost} </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5 my-auto ">
//                     <label className='my-auto'>Proposal Cost</label>
//                   </div>
//                   <div className="col-7">
//                     <p className='py-2 px-2'> {data.ProjectCost} </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label >PIU</label>
//                   </div>
//                   <div className="col-7">
//                     <p className='py-2 px-2 my-auto'> {data.piu ? data.piu : "--"}</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>GR Copy :</label>
//                   </div>
//                   <div className="col-7">
//                     <p><a href={`${apiurl}/ProjectDocsImages/${data.GRCopy}`} target='_blank'>{data.GRCopy}</a></p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>Budget Head</label>
//                   </div>
//                   <div className="col-7">
//                     <select name="BudgetHeadID" value={data.BudgetHeadID} id="" className='py-2' onChange={(e) => { HandleChangeData(e); HeadIDFetchOperation(e.target.value, "HeadID") }}>
//                       < option>Choose Head Budget Type</option>
//                       {relatedHeadID && relatedHeadID.map((val, index) => {
//                         return (
//                           <option key={index} value={val.HeadID}>{val.HeadName}</option>
//                         )
//                       })
//                       }
//                     </select>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5 my-auto ">
//                     <label className='my-auto'>Release Amount</label>
//                   </div>
//                   <div className="col-7">
//                     <input type="number" placeholder='Enter Release Amount' className='form-control py-2' name='ReleaseAmount' value={data.ApprovedWorkAmount} onChange={HandleChangeData} />
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>Release Date</label>
//                   </div>
//                   <div className="col-7">
//                     <input type="datetime-local" placeholder='Enter Release Date' className='form-control py-2' value={data.WorkOrderDate} name='ReleaseDate' onChange={HandleChangeData} />
//                   </div>
//                 </div>
//               </div>

//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>Release Sanction Copy Upload</label>
//                   </div>
//                   <div className="col-7">
//                     <input type="file" className='form-control py-2' id='ReleaseSanctionCopy' />
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12 ms-auto my-4">
//                 <div className="row">
//                   <div className="col-5">
//                   </div>
//                   <div className="col-7">
//                     <div className="col-12">
//                       <button className='px-4 py-1 btn btn-primary' onClick={handleSubmit}> Save</button>
//                       <button className='px-4 py-1 btn btn-danger mx-4'> Cancel</button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div> */}


//       {

//       }
//       <div className="col-12 ">
//         <h3 className='text-center fw-bold bg-light'>Release From FD/UTF</h3>
//         <div className="col-12 m-auto my-5 budgetContainer">
//           <div className="m-auto budgetElement">
//             {loading && (
//               <div
//                 style={{
//                   position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//                   display: 'flex', justifyContent: 'center', alignItems: 'center'
//                 }}>
//                 <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//                 <style>
//                   {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//                 </style>
//               </div>
//             )}
//             <form action="">
//               <div className="col-12 elements">
//                 <div className="row">
//                   <div className="col-5  ">
//                     <label>Financial Year</label>
//                   </div>
//                   <div className="col-7">
//                     <select name="FinancialYear" value={data.FinancialYear} id="" className='py-2' onChange={HandleChangeData}>
//                       <option value="null">Choose Financial Year</option>
//                       <option value="2024-25">2024 - 2025</option>
//                       <option value="2025-26">2025 - 2026</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>



//       {
//         // BugetEstimationDetail.length > 0 
//         false &&
//         <div className="col-11 m-auto">
//           <div className="row">

//             <table className='table  table-striped'>
//               <thead className='table-info'>
//                 <tr>
//                   <th>Sr no </th>
//                   <th>Year</th>
//                   <th>Budget Head</th>
//                   <th>Taluka</th>
//                   <th>Estimated Amount</th>
//                   <th>Limit Alloted Amount</th>
//                   <th>Liability Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {
//                   getGroupedEstimationData()
//                     .filter((i) => i.Year === data.FinancialYear)
//                     .map((val, index) => {
//                       return (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{val.Year}</td>
//                           <td>{val.BudgetHead}</td>
//                           <td>{val.Taluka || "--"}</td>
//                           <td>{val.EsitmateAmount}</td>
//                           <td>{val.LimitAllotedAmount}</td>
//                           <td>{Number(val.EsitmateAmount) - Number(val.LimitAllotedAmount)}</td>
//                         </tr>

//                       )
//                     })
//                 }
//               </tbody>
//             </table>


//           </div>
//         </div>
//       }


//       {
//         // BugetEstimationDetail.length > 0 
//         FinanceReleaseData.length > 0 &&
//         <div className="col-11 m-auto">
//           <div className="row">

//             <table className='table table-striped'>
//               <thead className='table-info'>
//                 <tr>
//                   <th>Sr no </th>
//                   <th>Financial Year</th>
//                   <th>Budget Head ID</th>
//                   <th>District</th>
//                   <th>Limit Allocated Amount</th>
//                   <th>Proposal</th>
//                   <th>Proposal Cost</th>
//                   <th>Release Amount Till Date</th>
//                   <th>Liability Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {
//                   getGroupedFinance()
//                     .filter((i) => i.Year === data.FinancialYear)
//                     .map((val, index) => {
//                       return (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{val.Year}</td>
//                           <td>{val.BudgetHead}</td>
//                           <td>{val.Taluka || "--"}</td>
//                           <td>{val.EsitmateAmount}</td>
//                           <td>{val.LimitAllotedAmount}</td>
//                           <td>{Number(val.EsitmateAmount) - Number(val.LimitAllotedAmount)}</td>
//                         </tr>

//                       )
//                     })
//                 }
//               </tbody>
//             </table>


//           </div>
//         </div>
//       }



//     </>
//   )
// }

// export default ReleasefromFinance




import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application';
import { Link } from 'react-router-dom';
import { Back32, Cancel32, ProposalCreation32, submit } from '../../../../../public/LoginImages/importimages';
import { apiurl } from '../../../../../path';

const ReleasefromFinance = () => {
  const context = useContext(AdminContext)
  const { GetBudgetHeadInfo } = context;

  const [technicalInwards, setTechnicalInwards] = useState([])
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState('');

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);




  const getTechnicalInwardsList = async () => {
    let data = await GetBudgetHeadInfo('All', 'GetAllFinanceFromReleaseTable')
    console.log("data------------", data);

    setTechnicalInwards(data)
    setFilteredBills(data);
  }

  useEffect(() => {
    getTechnicalInwardsList()
  }, []);

  let inwardList = []
  if (technicalInwards.length > 0) {
    inwardList = technicalInwards
  }
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = technicalInwards.filter(bill =>
      Object.values(bill).some((val) =>
        (val || '').toString().toLowerCase().includes(lowerSearchTerm)
      )
    );
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [searchTerm, technicalInwards]);



  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id]
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.ProposalID));
    } else {
      setSelectedBills([]);
    }
  };



  return (

    <>
      <div>

        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
            <h3>Release Finance List</h3>
            <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
          </div>


          <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 3px", borderRadius: "20px", width: "78vw", }}>
            <div style={{ overflowX: "auto", width: "78vw", borderRadius: "20px", }}>
              <table style={{ backgroundColor: "white", width: "130%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", }}>
                <thead style={{ borderTop: "none" }}>
                  <tr style={{ background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "12px", textAlign: "center", }}>
                    <th style={{ width: "6%" }}>वित्त प्रकाशन UID</th>
                    <th style={{ width: "5%" }}>आर्थिक वर्ष</th>
                    <th style={{ width: "6%" }}>जिल्हा</th>
                    <th style={{ width: "6%" }}>तालुका</th>
                    <th style={{ width: "10%" }}>शासन निर्णय क्रमांक</th>
                    <th style={{ width: "10%" }}>प्रस्तावाचे नाव</th>
                    <th style={{ width: "7%" }}>मंजूर रक्कम</th>
                    <th style={{ width: "9%" }}>आतापर्यंत वितरीत केलेली रक्कम</th>
                    <th style={{ width: "10%" }}>या आदेशान्वये वितरीत करावयाची रक्कम</th>
                    <th style={{ width: "10%" }}>वित्त जीआर मसुदा</th>
                    <th style={{ width: "8%" }}>दिनांक</th>

                  </tr>
                </thead>
                <tbody>
                  {
                    currentBills?.map((technicalInwards, index) => {
                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                      return (
                        <tr className='px-3' key={index} style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                          <td className='py-2'>{technicalInwards.ReleaseID}</td>
                          <td className='py-2'>{technicalInwards.FinancialYear}</td>
                          <td className='py-2'>{technicalInwards.District}</td>
                          <td className='py-2'>{technicalInwards.Taluka}</td>
                          <td className='py-2'>{technicalInwards.GRID}</td>
                          <td className='py-2'>{technicalInwards.ProposalID}</td>
                          <td className='py-2'>{technicalInwards.ProposalCost / 10000000} कोटी</td>
                          <td className='py-2'>{technicalInwards.ReleaseAmountTillDate / 10000000} कोटी</td>
                          <td className='py-2'>{technicalInwards.LimitAllottedAmount / 10000000} कोटी</td>
                          <td style={{ padding: '8px' }}>
                            {technicalInwards.ReleaseSanctionCopy ? (
                              <a href={`${apiurl}/FinancialReleaseGR/${technicalInwards.ReleaseSanctionCopy}`} target="_blank" rel="noreferrer">{technicalInwards.ReleaseSanctionCopy}</a>
                            ) : (
                              <p className='text-danger my-auto fw-bold'>No File</p>
                            )
                            }
                          </td>
                          <td className='py-2'>{new Date(technicalInwards.Date).toLocaleString()}</td>



                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>


          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            <div className='ms-auto' style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
              >
                Previous
              </button>
              <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
              >
                Next
              </button>
            </div>


          </div>
        </div>
      </div>




    </>

  )
}

export default ReleasefromFinance;
